const discountTypes = {
    CREATE_DISCOUNT_ACTION: "CREATE_DISCOUNT_ACTION",
    GET_LIST_DISCOUNT_ACTION: "GET_LIST_DISCOUNT_ACTION",
    GET_LIST_ALL_DISCOUNT_ACTION: "GET_LIST_ALL_DISCOUNT_ACTION",
    GET_DETAIL_DISCOUNT_ACTION: "GET_DETAIL_DISCOUNT_ACTION",
    UPDATE_DISCOUNT_ACTION: "UPDATE_DISCOUNT_ACTION",
    CREATE_DISCOUNT_SUCCESS: "CREATE_DISCOUNT_SUCCESS",
    GET_LIST_DISCOUNT_SUCCESS: "GET_LIST_DISCOUNT_SUCCESS",
    GET_LIST_ALL_DISCOUNT_SUCCESS: "GET_LIST_ALL_DISCOUNT_SUCCESS",
    GET_DETAIL_DISCOUNT_SUCCESS: "GET_DETAIL_DISCOUNT_SUCCESS",
    UPDATE_DISCOUNT_SUCCESS: "UPDATE_DISCOUNT_SUCCESS",
    CREATE_DISCOUNT_FAILED: "CREATE_DISCOUNT_FAILED",
    GET_LIST_ALL_DISCOUNT_FAILED: "GET_LIST_ALL_DISCOUNT_FAILED",
    GET_LIST_DISCOUNT_FAILED: "GET_LIST_DISCOUNT_FAILED",
    GET_DETAIL_DISCOUNT_FAILED: "GET_DETAIL_DISCOUNT_FAILED",
    UPDATE_DISCOUNT_FAILED: "UPDATE_DISCOUNT_FAILED"
}

export default discountTypes;